export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes60_buy.b877b2de.mp3";